import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from 'reactstrap';
import debounce from 'lodash/debounce';

class SearchInput extends Component {
  constructor(){
    super();

    this.state = {
      isSearching:false
    };
  }


  componentWillMount(){
    const onChange = (e) => {
      this.props.onChange(e);
      this.setState({isSearching:false});
    };

    this.handleChangeDebounced = debounce(onChange.bind(this),this.props.debounce);
  }

  componentWillReceiveProps(nextProps){
    const onChangeHasChanged = nextProps.onChange !== this.props.onChange,
      debounceHasChanged = nextProps.debounce !== this.props.debounce;

    const onChange = (e) => {
      nextProps.onChange(e);
      this.setState({isSearching:false});
    };

    if(onChangeHasChanged || debounceHasChanged){
      this.handleChangeDebounced = debounce(onChange.bind(this),nextProps.debounce);
    }
  }

  handleSearch(){}

  handleChange(event){
    event.persist();

    if(this.props.debounce > 0){
      this.setState({isSearching:true});
    }
    this.handleChangeDebounced(event.target.value);
  }


  render() {
    return (
      <InputGroup>
        <Input
          type='search'
          defaultValue={this.props.defaultValue}
          placeholder={this.props.placeholder}
          onChange={(e) => this.handleChange(e)}
          style={{borderRight:0}}
        />
        <InputGroupAddon addonType="append" className="TransparentAddon">
          <InputGroupText className="TransparentAddonText">
            {this.state.isSearching ? (
              <i className="fa fa-spinner fa-spin" aria-hidden="true" />
            ) : (
              <i className="fa fa-search" aria-hidden="true" />
            )}
          </InputGroupText>
        </InputGroupAddon>
      </InputGroup>
    );
  }
}

SearchInput.defaultProps = {
  defaultValue: '',
  onChange:() => {},
  debounce:0,
  placeholder:'Search'
}

SearchInput.propTypes = {
  defaultValue: PropTypes.string,
  onChange:PropTypes.func,
  placeholder:PropTypes.string,
  debounce:PropTypes.number
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/shared/components/SearchInput/SearchInput.js